var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconShare128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_11141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1148 31.522L27.4614 65.791",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4614 65.791L99.1148 100.06",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0191 79.8102C36.7617 79.8102 43.0383 73.5337 43.0383 65.7911C43.0383 58.0486 36.7617 51.772 29.0191 51.772C21.2766 51.772 15 58.0486 15 65.7911C15 73.5337 21.2766 79.8102 29.0191 79.8102Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1144 45.5412C106.857 45.5412 113.133 39.2646 113.133 31.5221C113.133 23.7795 106.857 17.5029 99.1144 17.5029C91.3718 17.5029 85.0952 23.7795 85.0952 31.5221C85.0952 39.2646 91.3718 45.5412 99.1144 45.5412Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1144 114.079C106.857 114.079 113.133 107.803 113.133 100.06C113.133 92.3176 106.857 86.041 99.1144 86.041C91.3718 86.041 85.0952 92.3176 85.0952 100.06C85.0952 107.803 91.3718 114.079 99.1144 114.079Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_11141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconShare128);
export default __webpack_public_path__ + "static/media/pictogramBeaconShare128.900177594b2e4e083491026d2e600d0d.svg";
export { ForwardRef as ReactComponent };